import { render } from "./AyudaUsuario.vue?vue&type=template&id=48b8cdfe&scoped=true"
import script from "./AyudaUsuario.vue?vue&type=script&lang=js"
export * from "./AyudaUsuario.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=48b8cdfe&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b8cdfe"]])

export default __exports__